import Loadable from 'react/components/loadable';

const DashboardRevenueTab = Loadable({
  loader: () => import('../../pages/dashboard/revenue/dashboard_revenue_tab'),
});

angular.module('gym').value('DashboardRevenueTab', DashboardRevenueTab);
